import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-pa-react';
// import VeracityCheckPage from '../ml-capability-quoteandbind-common-react/pages/VeracityCheck/VeracityCheckPage';
import MLHVQDiscrepanciesCheckPage from '../ml-capability-quoteandbind-common-react/pages/MLHVQDiscrepanciesCheck/MLHVQDiscrepanciesCheckPage';

// import { VeracityCheckPage as GatewayVeracityCheckPage, MLHVQDiscrepanciesCheckPage } from 'ml-capability-quoteandbind-common-react';

import GWQuotePAPolicyDetailsPage from './pages/PolicyDetails/PolicyDetailsPage';
import GatewayPrefillPage from './pages/GatewayPrefillPage/GatewayPrefillPage';
import GatewayDriversPage from './pages/GatewayDriversPage/GatewayDriversPage';
import GatewayVehiclesPage from './pages/GatewayVehiclesPage/GatewayVehiclesPage';
import AdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage';
import GatewayAdditionalInformationPreBindPage from './pages/GatewayAdditionalInformationPreBind/GatewayAdditionalInformationPreBindPage';
import GatewayCompRaterValidateInformationPage from './pages/GatewayCompRaterValidateInformationPage/GatewayCompRaterValidateInformationPage';

setComponentMapOverrides(
    {
        GWQuotePAPolicyDetailsPage: { component: 'GWQuotePAPolicyDetailsPage' },
        GatewayPrefillPage: { component: 'GatewayPrefillPage' },
        GatewayDriversPage: { component: 'GatewayDriversPage' },
        GatewayVehiclesPage: { component: 'GatewayVehiclesPage' },
        AdditionalInformationPage: { component: 'AdditionalInformationPage' },
        GatewayAdditionalInformationPreBindPage: { component: 'GatewayAdditionalInformationPreBindPage' },
   //     GatewayVeracityCheckPage: { component: 'GatewayVeracityCheckPage' },
        MLHVQDiscrepanciesCheckPage: { component: 'MLHVQDiscrepanciesCheckPage' },
        GatewayCompRaterValidateInformationPage: { component: 'GatewayCompRaterValidateInformationPage' },
    },
    {
        GWQuotePAPolicyDetailsPage,
        GatewayPrefillPage,
        GatewayDriversPage,
        GatewayVehiclesPage,
        AdditionalInformationPage,
        GatewayAdditionalInformationPreBindPage,
     //   GatewayVeracityCheckPage,
        MLHVQDiscrepanciesCheckPage,
        GatewayCompRaterValidateInformationPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PEPAWizard } from './PEPAWizard';
export { default as MLAgentQuoteStickyAutoComponent } from './components/MLAgentQuoteStickyAutoComponent/MLAgentQuoteStickyAutoComponent';
export { default as MLCRAdditionalInformationComponent } from './components/MLCRAdditionalInformationComponent/MLCRAdditionalInformationComponent';
export { default as MLCRDriversValidationComponent } from './components/MLCRDriversValidationComponent/MLCRDriversValidationComponent';
export { default as MLCRPriorInsuranceValidationComponent } from './components/MLCRPriorInsuranceValidationComponent/MLCRPriorInsuranceValidationComponent';
export { default as MLCRVehiclesValidationComponent } from './components/MLCRVehiclesValidationComponent/MLCRVehiclesValidationComponent';

// Comment Removed -GatewayVeracityCheckPage, MLHVQDiscrepanciesCheckPage